import maputilities from '@smarttransit/map-utilities'

export function isAgentTopUpPassengerTransaction (transaction) {
  if (!transaction || transaction.logType !== 'purchased_credit') return false
  return Boolean(transaction.transactionLogReferenceId)
}

export function getAgentTopUpTransactionLogId (transaction) {
  if (!transaction || transaction.logType !== 'purchased_credit') return null
  if (transaction.transactionLogReferenceId) return transaction.transactionLogReferenceId
  if (transaction.logMetadata && transaction.logMetadata.agentTransactionLogId) {
    return transaction.logMetadata.agentTransactionLogId
  }
  return null
}

export function formatAgentDetailsLabel (stUser) {
  if (!stUser) return ''
  return '<code>' + JSON.stringify({
    phoneNumber: stUser.phone || stUser.phoneNumber || null,
    email: stUser.email || null,
    firstName: stUser.firstName,
    lastName: stUser.lastName
  }, null, 2) + '</code>'
}

export function getAgentStUserFromJoinedLog (agentLog) {
  if (!agentLog || !agentLog.rawAgentProfile) return null
  return agentLog.rawAgentProfile.stUser || null
}

export function shouldShowDateRecorded (transaction) {
  if (!transaction || !transaction.dateRecorded) return false
  if (transaction.dateRecordedLabel && transaction.dateCreatedLabel) {
    return transaction.dateRecordedLabel !== transaction.dateCreatedLabel
  }
  if (!transaction.dateCreated) return true
  return String(transaction.dateRecorded) !== String(transaction.dateCreated)
}

const RELATED_USER_ACTION_FIELDS = [
  { key: 'requestedByStUserId', label: 'Requested by' },
  { key: 'stUserId', label: 'User' },
  { key: 'expiredByStUserId', label: 'Expired by' }
]

export function getRelatedTransactionUserActions (logMetadata) {
  if (!logMetadata) return []
  const actions = []
  for (let i = 0; i < RELATED_USER_ACTION_FIELDS.length; i++) {
    const field = RELATED_USER_ACTION_FIELDS[i]
    if (logMetadata[field.key]) {
      actions.push({ label: field.label, stUserId: logMetadata[field.key] })
    }
  }
  return actions
}

function appendDetailRow (rows, label, value) {
  if (value === null || value === undefined || value === '') return
  rows.push({ label: label, value: value })
}

export function getEventDetailRows (event) {
  if (!event) return []
  const rows = []
  appendDetailRow(rows, 'Event name', event.eventName)
  appendDetailRow(rows, 'Event ID', event.eventId)
  appendDetailRow(rows, 'Event date', event.eventDateLabel || event.eventDate)
  appendDetailRow(rows, 'Pickup time', event.pickupTime)
  appendDetailRow(rows, 'Flat rate fee', event.flatRateFee)
  appendDetailRow(rows, 'Pickup stop', event.busStopLabel)
  appendDetailRow(rows, 'Origin', event.originLabel)
  appendDetailRow(rows, 'Destination', event.destinationLabel)
  if (event.isReturnEventTicket === true) appendDetailRow(rows, 'Return trip', 'Yes')
  if (event.isReturnEventTicket === false) appendDetailRow(rows, 'Return trip', 'No')
  return rows
}

export function getPersonDetailRows (person) {
  if (!person) return []
  const rows = []
  const name = [person.firstName, person.lastName].filter(Boolean).join(' ')
  appendDetailRow(rows, 'Name', name)
  appendDetailRow(rows, 'Phone', person.phoneNumber || person.phone)
  appendDetailRow(rows, 'Email', person.email)
  return rows
}

export function toViewedPerson (stUser) {
  if (!stUser) return null
  return {
    phoneNumber: stUser.phoneNumber || stUser.phone || null,
    email: stUser.email || null,
    firstName: stUser.firstName,
    lastName: stUser.lastName
  }
}

export function getReconfirmCodeLabel (logMetadata) {
  if (!logMetadata || !logMetadata.reconfirmCode) return ''
  return String(logMetadata.reconfirmCode).toUpperCase()
}

export function formatTripRouteLabel (trip, stRouteLabel) {
  if (stRouteLabel) return stRouteLabel
  if (!trip) return ''
  return maputilities.joinRouteLabel(trip.originLabel, trip.destinationLabel)
}
